import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import { REDIRECT } from '@/store/mutation-types'
import SimpleRouter from '@/components/SimpleRouter'

const Login = () => import(/* webpackChunkName: "login" */ '@/views/accueil/Login')
const Inscription = () => import(/* webpackChunkName: "login" */ '@/views/accueil/Inscription')
const Validate = () => import(/* webpackChunkName: "login" */ '@/views/accueil/Validate')
const RecoverPassword = () => import(/* webpackChunkName: "login" */ '@/views/accueil/RecoverPassword.vue')
const ChangePassword = () => import(/* webpackChunkName: "login" */ '@/views/accueil/ChangePassword.vue')

const Validateusers = () => import(/* webpackChunkName: "users" */ '@/views/users/ValidateUsers')

const Exploitations = () => import(/* webpackChunkName: "exploitation" */ '@/views/Exploitations')
const Exploitation = () => import(/* webpackChunkName: "exploitation" */ '@/views/exploitation/Exploitation')
const ExploitInfo = () => import(/* webpackChunkName: "info" */ '@/views/exploitation/Information')
const ExploitExploitant = () => import(/* webpackChunkName: "exploitant" */ '@/views/exploitation/Exploitant')

const IlotList = () => import(/* webpackChunkName: "ilot" */ '@/views/ilot/List')
const Ilot = () => import(/* webpackChunkName: "ilot" */ '@/views/ilot/Ilot')
const CultureList = () => import(/* webpackChunkName: "culture" */ '@/views/culture/List')
const Culture = () => import(/* webpackChunkName: "culture" */ '@/views/culture/Culture')

const Simulation = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/Simulation')
const SimulationList = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/List')

const SimulationResult = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/Resultat')
const SimulationChoice = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/Choix')
const SimulationIlot = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/Ilot')
const SimulationResultIlot = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/ResultatIlot')
const SimulationResultCulture = () => import(/* webpackChunkName: "simulation" */ '@/views/simulation/ResultatCulture')
const SimulationResultGraph = () => import(/* webpackChunkName: "graphs" */ '@/views/simulation/ResultGraph')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/exploitations',
      name: 'exploitations',
      component: Exploitations
    },
    {
      path: '/exploitations/:idExploitation',
      component: Exploitation,
      props: true,
      meta: {
        breadcrumb: {
          getter: 'nomExploitation',
          routeName: 'exploitation_information'
        }
      },
      children: [
        {
          path: 'infos',
          name: 'exploitation_information',
          props: true,
          component: ExploitInfo,
          meta: {
            breadcrumb: {
              text: 'Informations'
            }
          }
        },
        {
          path: 'exploitant',
          name: 'exploitation_exploitant',
          props: true,
          component: ExploitExploitant,
          meta: {
            breadcrumb: {
              text: 'Exploitant'
            }
          }
        },
        {
          path: 'ilots',
          component: SimpleRouter,
          meta: {
            breadcrumb: {
              text: 'Îlots',
              routeName: 'exploitation_ilots'
            }
          },
          children: [
            {
              path: '',
              name: 'exploitation_ilots',
              props: true,
              component: IlotList,
              meta: {
                breadcrumb: false
              }
            },
            {
              path: ':idIlot',
              name: 'ilot',
              props: true,
              component: Ilot,
              meta: {
                breadcrumb: {
                  getter: 'nomIlot'
                }
              }
            }
          ]
        },
        {
          path: 'cultures',
          component: SimpleRouter,
          meta: {
            breadcrumb: {
              text: 'Cultures',
              routeName: 'exploitation_cultures'
            }
          },
          children: [
            {
              path: '',
              name: 'exploitation_cultures',
              props: true,
              component: CultureList,
              meta: {
                breadcrumb: false
              }
            },
            {
              path: ':idCulture',
              name: 'culture',
              props: true,
              component: Culture,
              meta: {
                breadcrumb: {
                  getter: 'nomCulture'
                }
              }
            }]
        },
        {
          path: 'simulations',
          component: SimpleRouter,
          meta: {
            breadcrumb: {
              text: 'Simulations',
              routeName: 'exploitation_simulations'
            }
          },
          children: [
            {
              path: '',
              name: 'exploitation_simulations',
              props: true,
              component: SimulationList,
              meta: {
                breadcrumb: false
              }
            },
            {
              path: ':idSimulation',
              props: true,
              component: Simulation,
              meta: {
                breadcrumb: {
                  getter: 'nomSimulation',
                  routeName: 'simulation'
                }
              },
              children: [
                {
                  path: 'choix',
                  name: 'simulation',
                  props: true,
                  component: SimulationChoice,
                  meta: {
                    breadcrumb: {
                      text: 'Choix'
                    }
                  },
                  children: [{
                    path: ':idIlot',
                    name: 'simulation_ilot',
                    props: true,
                    component: SimulationIlot,
                    meta: {
                      breadcrumb: {
                        getter: 'nomIlotById',
                        params: 'idIlot'
                      }
                    }
                  }]
                },
                {
                  path: 'resultat',
                  name: 'simulation_result',
                  props: true,
                  component: SimulationResult,
                  meta: {
                    breadcrumb: false
                  },
                  children: [
                    {
                      path: '',
                      name: 'simulation_result_ilot',
                      props: true,
                      component: SimulationResultIlot,
                      meta: {
                        filtre: {
                          culture: false
                        },
                        breadcrumb: {
                          text: 'Résultat par îlots'
                        }
                      }
                    },
                    {
                      path: 'culture',
                      name: 'simulation_result_culture',
                      props: true,
                      component: SimulationResultCulture,
                      meta: {
                        filtre: {
                          ilot: true,
                          culture: false
                        },
                        breadcrumb: {
                          text: 'Résultat par culture'
                        }
                      }
                    },
                    {
                      path: 'graph',
                      name: 'simulation_result_graph',
                      props: true,
                      component: SimulationResultGraph,
                      meta: {
                        breadcrumb: {
                          text: 'Graphique'
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/inscription',
      name: 'inscription',
      component: Inscription,
      meta: { requiresAuth: false }
    },
    {
      path: '/recoverPassword',
      name: 'recoverPassword',
      component: RecoverPassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/changePassword/:token',
      name: 'changePassword',
      props: true,
      component: ChangePassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/validate/:token',
      name: 'validate',
      props: true,
      component: Validate,
      meta: { requiresAuth: false }
    },
    {
      path: '/validateusers',
      name: 'validateusers',
      component: Validateusers
    },
    {
      path: '*',
      redirect: { name: 'exploitations' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.auth.authenticated || to.matched.every(record => record.meta.requiresAuth === false)) {
    store.dispatch('countUsers')
    next()
  } else {
    store.commit(REDIRECT, to.fullPath)
    next({
      name: 'login'
    })
  }
})

export default router
